import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { DraftStatusType, serviceModel } from '~/models';
import { customPagesEnabled } from '~/models/custom-page/model';
import { fromDatestampObjectToExpirationDate } from '~/models/expiration-date';
export function mapAgreementToDraft(agreement, mappingOptions) {
    var _agreement_customPages;
    var _agreement_signatories;
    const isWithdrawToEdit = mappingOptions.strategy === 'withdraw-to-edit';
    const isDuplicateProposal = mappingOptions.strategy === 'duplicate-proposal';
    const isDuplicateAgreement = mappingOptions.strategy === 'duplicate-agreement';
    const cpEnabled = customPagesEnabled(!!mappingOptions.customPagesFFEnabled, (_agreement_customPages = agreement.customPages) !== null && _agreement_customPages !== void 0 ? _agreement_customPages : []);
    const shouldDuplicateServiceOrBundles = agreement.services.length > 0 ? 'services' : 'bundles';
    const translateService = (s)=>serviceModel.toDTO(serviceModel.setAwaitingApproval(s));
    return {
        id: generateUniqueId('draft'),
        netTerms: agreement.netTerms,
        coverLetter: agreement.coverLetter,
        extraClause: agreement.extraClause || '',
        requirePaymentMethod: agreement.requirePaymentMethod || false,
        allowManualPayments: agreement.allowManualPayments,
        isExistingCustomer: false,
        lastModifiedOn: Date.now(),
        lastModifiedBy: null,
        legalTermsDocuments: agreement.legalTermsDocuments,
        services: shouldDuplicateServiceOrBundles === 'services' ? agreement.services.map(translateService) : [],
        serviceBundles: agreement.serviceBundles != null && shouldDuplicateServiceOrBundles === 'bundles' ? {
            bundles: agreement.serviceBundles.bundles.map((bundle)=>_object_spread_props(_object_spread({}, bundle), {
                    services: bundle.services.map(translateService)
                }))
        } : undefined,
        customNotificationText: agreement.customNotificationText,
        title: agreement.title,
        effectiveDate: isWithdrawToEdit ? agreement.effectiveDate : null,
        feeControls: agreement.feeControls,
        clientContactId: isDuplicateAgreement ? null : agreement.clientContactId,
        isSample: agreement.isSample,
        amendmentsApprovalMethod: agreement.amendmentsApprovalMethod,
        invoicesApprovalMethod: agreement.invoicesApprovalMethod,
        requestAccountantAccess: agreement.requestAccountantAccess,
        reviewers: isWithdrawToEdit || isDuplicateProposal ? [
            ...((_agreement_signatories = agreement.signatories) === null || _agreement_signatories === void 0 ? void 0 : _agreement_signatories.map((s)=>{
                return {
                    firstName: s.firstName || undefined,
                    lastName: s.lastName || undefined,
                    email: s.email,
                    isSignatory: true
                };
            })) || [],
            ...agreement.reviewers.map((r)=>({
                    firstName: r.firstName || undefined,
                    lastName: r.lastName || undefined,
                    email: r.email,
                    isSignatory: false
                }))
        ] : [],
        introVideo: cpEnabled ? null : agreement.introVideo,
        customPages: agreement.customPages,
        expirationDate: fromDatestampObjectToExpirationDate(agreement.expirationDate, agreement.createdOn),
        status: {
            type: DraftStatusType.Active
        }
    };
}
